module.exports = __webpack_public_path__ + "logo.png?d41c6ef427d8ea36c6b3ce248735d932";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 3
// module chunks = 0